<template>
  <div class="fixed-height-img-wrapper">
    <div class="media-wrapper">
      <div class="img-wrapper">
        <img :src="imgSrc" alt="image">
      </div>
    </div>
    <div class="content-wrapper">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fixed-height-img',
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="sass" scoped>
.fixed-height-img-wrapper
  position: relative
  overflow: hidden
  .media-wrapper
    width: 100vw
    height: 75vh
    .img-wrapper
      width: 100%
      height: 100%
      img
        width: 100%
        height: 100%
        object-fit: cover

/** Mobile */
@media only screen and (max-width: 768px)
  .fixed-height-img-wrapper
    .media-wrapper
      width: 100vw
      height: 80vw
      .img-wrapper
        width: 100%
        height: 100%
        img
          width: 100%
          height: 100%
          object-fit: cover
</style>
